<template>
    <div >
            <slot />
        </div>
</template>

<script setup lang="ts">
import {onMounted} from "vue";
import {useSettings} from "@/hooks/useSettings";

const isMobile = window.innerWidth <= 768;

const {isProduction} = useSettings();

const loadSmartlookScript = () => {
  // A função só executa se estiver em produção e se o script ainda não tiver sido adicionado.
  if (isProduction.value && !document.getElementById('smartlook-script')) {
    const script = document.createElement('script');
    script.id = 'smartlook-script';
    script.type = 'text/javascript';
    script.innerHTML = `
      window.smartlook||(function(d) {
        var o=smartlook=function(){ o.api.push(arguments)},h=d.getElementsByTagName('head')[0];
        var c=d.createElement('script');o.api=new Array();c.async=true;c.type='text/javascript';
        c.charset='utf-8';c.src='https://web-sdk.smartlook.com/recorder.js';h.appendChild(c);
      })(document);
      smartlook('init', '29f9c1e0538d12e12a470c80467fd3bfd9bcd2c7', { region: 'eu' });
    `;
    document.head.appendChild(script);

    // Remove os listeners após a primeira execução para não serem acionados novamente.
    window.removeEventListener('scroll', loadSmartlookScript);
    window.removeEventListener('mousemove', loadSmartlookScript);
    window.removeEventListener('touchstart', loadSmartlookScript);
  }
};


onMounted(() => {
    window.addEventListener('scroll', loadSmartlookScript, { once: true });
    window.addEventListener('mousemove', loadSmartlookScript, { once: true });
    window.addEventListener('touchstart', loadSmartlookScript, { once: true });
});
</script>
